import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useFacilityRole } from "./useFacilityRole";

/**
 * Wraps a route that only makes sense for facility owners (settings,
 * walk-the-facility). Maintainers landing on the URL directly get a
 * friendly "owner only" card instead of broken UI or a 403 fetch.
 *
 * The wrapper itself does not redirect — we want the volunteer to see
 * where they are and what they can't do, not be silently bounced.
 */
export function OwnerOnly({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const facilityId = Number(id);
  const { isOwner, isLoading } = useFacilityRole(facilityId);
  if (isLoading) {
    return <p className="p-6 text-sm text-slate-500">…</p>;
  }
  if (!isOwner) {
    return (
      <div className="mx-auto max-w-md rounded-lg border border-slate-200 bg-white p-6 text-center">
        <p className="text-sm font-medium text-slate-900">
          {t("facility.owner_only_heading")}
        </p>
        <p className="mt-2 text-sm text-slate-500">
          {t("facility.owner_only_blurb")}
        </p>
      </div>
    );
  }
  return <>{children}</>;
}
